import { Modal, ConfigProvider, Upload, message } from "antd";
import ImgCrop from "antd-img-crop";
import { validateFileType, validateImageDimension } from "../../utils/Common";
import useScrollLock from "../../hooks/useScrollLock";
import ImageUploadWithCropAndWebp from "../common/ImageUploadWithCropAndWebp";
import React from "react";

export default function ImageUploadModal({
  openModal,
  records,
  handleOk,
  handleCancel,
  aspect = 1 / 1,
  context = "",
}) {
  // Lock scroll when modal is open
  useScrollLock(openModal);
  const beforeCrop = async (file) => {
    let errMsg = validateFileType(file);

    if (errMsg) {
      message.error(errMsg);
      return;
    }

    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        const { width, height } = img;

        errMsg = validateImageDimension(context, width, height);

        if (errMsg) {
          message.error(errMsg);
          reject(false);
        } else {
          resolve(true);
        }
      };
    });
  };

  const onImageChange = ({ fileList }) => {
    if (fileList.length === 0) {
      records.setFileList([]);
    }

    const file = fileList[0].originFileObj;

    let errMsg = validateFileType(file);

    if (errMsg) {
      return;
    }

    // Read the image and extract dimensions
    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const { width, height } = img;

        errMsg = validateImageDimension(context, width, height);

        if (errMsg) {
          return;
        }

        // If valid, set cropped file
        records.setCroppedFile(event.target.result);
        records.setFileList(fileList);
      };
    };

    reader.readAsDataURL(file);
  };

  const beforeUpload = async (file) => {
    records.setCroppedFile(file);
    return true;
  };

  const deleteImage = (file) => {
    const updatedFileList = records.fileList.filter((item) => item.uid !== file.uid);
    records.setFileList(updatedFileList);
    records.setCroppedFile(null);
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            defaultHoverBorderColor: "#FFD700",
            defaultHoverColor: "#000000",
            fontFamily: "ubold",
          },
        },
      }}
    >
      <Modal
        open={openModal}
        okButtonProps={{
          style: {
            backgroundColor: "#FFD700",
            color: "#000000",
            fontFamily: "ubold",
          },
        }}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <div className="flex flex-col font-uregular bg-[#FAFAFA]">
          <div className="flex items-center justify-around">
            <div
              className="ml-[4px] text-md font-bold font-uregular flex f
            lex-row text-[#FCBD10]"
            >
              <div>{records.titleText}...</div>
            </div>
            <div className='mt-4'>
              <ImageUploadWithCropAndWebp fileList={records.fileList} setFileList={records.setFileList} deleteImage={deleteImage} minWidth={500}/>
            </div>
          </div>
          {context === "OFFER_IMAGE" && (
            <div className="text-sm text-red-400 mt-5">
              Min width: 530 and Min height: 300. Recommended ratio 16:9
            </div>
          )}
        </div>
      </Modal>
    </ConfigProvider>
  );
}
